export { default } from './P9InformationTeaser';
